<template>
  <div class="el-button is-plain" @click="isFilterWindow = true">
    <el-icon><MoreFilled /></el-icon>
  </div>
  <el-drawer
    title="Sort&Filter By"
    v-model="isFilterWindow"
    direction="btt"
    class="createTask"
    size="100%"
    @open="loadZoneList"
  >
    <div class="lists">
      <div class="lists__title">Sort By</div>

      <div
        @click="getSortData(item)"
        class="lists__item"
        v-for="(item, key) in lists"
        :key="key"
        :class="{
          active: item.key == chooseSort.key,
        }"
      >
        <el-icon>
          <component :is="item.icon" />
        </el-icon>
        {{ item.name }}
      </div>
    </div>
    <el-divider />
    <div class="lists">
      <div class="lists__title">Filter By</div>
      <el-form label-position="top">

          
        <div style="padding-bottom: 10px; padding-top: 10px">Location</div>
        <div style="max-width: 100vw; padding-bottom: 10px">
            <el-input v-on:keyup.enter="searchLocation" v-model="filter.location.value" style="width: 75%; padding-right: 10px" placeholder="Write location (or part name)" />
            <el-button style="width: 25%; float: right; margin-right: 0" type="success" @click="searchLocation" plain>Search</el-button>
        </div>


        <el-form-item label="Zone">
          <el-select
            v-model="filter.zoneId.value"
            placeholder="Choose zone"
            @change="filterByZone()"
            class="w-100"
            :clearable="true"
          >
            <el-option label="All" value="0" />
            <el-option
              v-for="item in zoneList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Group">
          <el-select
            v-model="filter.groupId.value"
            placeholder="Choose group"
            @change="filterByGroup()"
            class="w-100"
            :clearable="true"
          >
            <el-option label="All" value="0" />
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="Created At">
          <el-date-picker
            v-model="filter.createdAt.value"
            type="date"
            format="YY/MM/DD"
            placeholder="Pick a date"
            @change="applyFilter()"
            @blur="applyFilter()"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Must complite At">
          <el-date-picker
            v-model="filter.mustDone.value"
            type="date"
            format="YY/MM/DD"
            placeholder="Pick a deadline"
            @change="applyFilter()"
            @blur="applyFilter()"
            :clearable="false"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="Favorite only">
          <el-checkbox
            @click="applyFilter()"
            v-model="filter.favorite.value"
            label="Favorite only"
            size="large"
          />
        </el-form-item>

        <el-form-item label="Only status complite">
          <el-checkbox
            @click="applyFilter()"
            v-model="filter.status.value"
            label="Only status complite"
            size="large"
            false-label="completed"
            true-label="active"
          />
        </el-form-item>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import bus from "vue3-eventbus";
export default {
  data() {
    return {
      isFilterWindow: false,
      zoneListLoaded: false,
      chooseSort: {},
      chooseFilter: {},
      groupId: {},
      zoneId: {},
      filterCopy: {
        favorite: {
          key: "favorite",
          value: false,
        },
        status: {
          key: "status",
          value: "completed",
        },
        groupId: {
          key: "groupId",
          value: null,
        },
        zoneId: {
          key: "zoneId",
          value: null,
        },
        mustDone: {
          key: "mustDone",
          value: null,
        },
        createdAt: {
          key: "createdAt",
          value: null,
        },
        location: {
          key: "location",
          value: null,
        },
      },
      filter: {
        favorite: {
          key: "favorite",
          value: false,
        },
        status: {
          key: "status",
          value: "completed",
        },
        groupId: {
          key: "groupId",
          value: null,
        },
        zoneId: {
          key: "zoneId",
          value: null,
        },
        mustDone: {
          key: "mustDone",
          value: null,
        },
        createdAt: {
          key: "createdAt",
          value: null,
        },
        location: {
          key: "location",
          value: null,
        },
      },
      params: {},
      dir: 1,
      lists: [
        {
          name: "Priority",
          key: "priority",
          icon: "Star",
        },
        {
          name: "Title",
          key: "title",
          icon: "Sort",
        },
        {
          name: "Date",
          key: "createdAt",
          icon: "Calendar",
        },
        {
          name: "Zone",
          key: "zone",
          icon: "Location",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("User", ["groupList", "zoneList"]),
  },
  methods: {
    ...mapActions("User", ['getZoneList']),

    loadZoneList() {
      if (this.zoneListLoaded) {
        return;
      }
      this.zoneListLoaded = true;
      this.getZoneList();
    },

    searchLocation () {
      const filterKey = this.filter.location.key;
      const filterValue = this.filter.location.value;
      
      if (filterValue) {
        const url = new URL(window.location);
        url.searchParams.set(`filter[${filterKey}]`, filterValue);

        window.history.pushState({}, "", url);

        this.$router.replace(`${this.$route.path}?${url.search}`);
        this.isFilterWindow = false;
      }
    },
    applyFilter() {
      const url = new URL(window.location);
      this.$emit("applayFilter");
      let params = {};
      for (let filter in this.filter) {
        const filterKey = this.filter[filter].key;
        const filterValue = this.filter[filter].value;

        if (filterValue !== null && `${filterValue}`.length !== 0) {
          if (typeof filterKey === "string") {
            params[`filter[${filterKey}]`] = filterValue;
          } else {
            params[`filter[${filterKey.key}]`] = filterKey.value;
            params[`filter[${filterKey.filterBy}]`] = filterValue;
          }

          if (filterKey == "createdAt" || filterKey == "mustDone") {
            params[`filter[${filterKey}]`] = Math.floor(
              new Date(filterValue).getTime() / 1000
            );
            url.searchParams.set(
              `filter[${filterKey}]`,
              Math.floor(new Date(filterValue).getTime() / 1000)
            );
          } else {
            url.searchParams.set(`filter[${filterKey}]`, filterValue);
          }
        }
      }

      window.history.pushState({}, "", url);

      this.$router.replace(`${this.$route.path}?${url.search}`);
      this.isFilterWindow = false;
    },
    filterByGroup(isClear = false) {
      const url = new URL(window.location);
      if (isClear) {
        this.filter.groupId.value = null;

        this.$router.replace(`${this.$route.path}`);
      } else {
        if (this.filter.groupId.value == 0) {
          url.searchParams.delete("filter[groupId]");
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        } else {
          url.searchParams.set("filter[groupId]", this.filter.groupId.value);
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        }
      }
      this.isFilterWindow = false;
    },
    filterByZone(isClear = false) {
      const url = new URL(window.location);
      if (isClear) {
        this.filter.zoneId.value = null;

        this.$router.replace(`${this.$route.path}`);
      } else {
        if (this.filter.zoneId.value == 0) {
          url.searchParams.delete("filter[zoneId]");
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        } else {
          url.searchParams.set("filter[zoneId]", this.filter.zoneId.value);
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        }
      }
      this.isFilterWindow = false;
    },
    getSortData(item) {
      let dir = "ASC";
      if (this.dir == 1) {
        dir = "DESC";
        this.dir = 0;
      } else {
        dir = "ASK";
        this.dir = 1;
      }

      this.chooseSort = item;

      const url = new URL(window.location);
      url.searchParams.delete(`sort[${this.chooseSort.key}]`);

      url.searchParams.set(`sort[${item.key}]`, dir);
      window.history.pushState({}, "", url);
      this.$router.replace(`${this.$route.path}?${url.search}`);

      this.isFilterWindow = false;
    },
  },
  mounted() {
    bus.on('resetFilter', (e) => {
      this.filter = JSON.parse(JSON.stringify(this.filterCopy))
    })
  }
};
</script>

<style lang="scss" scoped>
.lists {
  font-size: 14px;
  font-weight: 400;
  &__item {
    cursor: pointer;
    padding: 10px;
    &.active {
      color: #67c23a;
    }
  }
  &__title {
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>